import React from 'react'
import PropTypes from 'prop-types'
import { ListGroupItem } from 'react-bootstrap'
import styled from 'styled-components'
import { Square } from 'styled-icons/fa-regular/Square'
import { CheckSquare } from 'styled-icons/fa-regular/CheckSquare'

const CheckBox = styled(CheckSquare)`color: dodgerblue;`
const checkBox = checked => checked ? <CheckBox size={14}/> : <Square size={14}/>

class ListItem extends React.Component {

  handleClick = e => {
    e.preventDefault()
    this.props.onItemClick(this.props.eventKey)
  }

  render() {
    const { children, multiple, className, checked } = this.props

    return (
      <ListGroupItem className={className} onClick={this.handleClick} active={!multiple && checked}>
        { multiple ? checkBox(checked) : null }{' '}
        {children}
      </ListGroupItem>
    )
  }
}

ListItem.defaultProps = {
  multiple: false,
  onItemClick: () => {}
}

ListItem.propTypes = {
  multiple: PropTypes.bool,
  onItemClick: PropTypes.func,
}

export default ListItem



// WEBPACK FOOTER //
// ./src/components/widgets/ListItem.js